<template>
  <div class="row justify-content-center align-items-center">
    <div class="col-md-8 col-sm-12 col-s-8 col-xl-8 col-xxl-6">
      <div id="input">
        <ErrorDisplay
          v-if="error"
          :error="error"
          @clear="error = ''"
        />
        <component
          :is="config?.devices_dropdown ? 'DeviceSelectorList' : 'DeviceSelector'"
          :devices="config?.devices || []"
          @device-selected="handleDeviceSelected"
        />
        <br v-if="selectedNode">

        <CommandSelector
          v-if="selectedNode"
          :commands="allowedCommands"
          @command-selected="handleCommandSelected"
        />
        <br v-if="selectedNode && command">

        <CommandInput
          v-if="selectedNode && command"
          :command="command"
          :client-ip="clientIP"
          :dns-resolver="config?.dns_resolver"
          :loading="reqLoading"
          @execute="handleExecute"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DeviceSelector from '../components/DeviceSelector.vue'
import DeviceSelectorList from '../components/DeviceSelectorList.vue'
import CommandSelector from '../components/CommandSelector.vue'
import CommandInput from '../components/CommandInput.vue'
import ErrorDisplay from '../components/ErrorDisplay.vue'

export default {
  name: 'InputPage',
  components: {
    DeviceSelector,
    DeviceSelectorList,
    CommandSelector,
    CommandInput,
    ErrorDisplay
  },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedNode: null,
      command: null,
      commandId: null,
      reqLoading: false,
      clientIP: null,
      error: ''
    }
  },
  computed: {
    allowedCommands() {
      if (!this.selectedNode?.allowed_commands || !this.config?.commands) return [];
      return this.config.commands.filter(command => 
        this.selectedNode.allowed_commands.includes(command.id)
      );
    }
  },
  methods: {
    handleDeviceSelected(device) {
      this.selectedNode = device
      this.command = null
      this.commandId = null
      this.error = ''
    },
    handleCommandSelected(command) {
      this.command = command
      this.commandId = command.id
      this.error = ''
    },
    async handleExecute(input) {
      this.reqLoading = true
      this.error = ''
      try {
        const response = await fetch('/laniakea?q=makeRequest&device_id=' +
          this.selectedNode.id + '&command_id=' + this.command.id + "&input=" + input)
        const data = await response.json()

        if (data.status === "success") {
          this.$router.push({
            name: 'result',
            params: {
              requestId: data.data.id,
              cached: data.data.cache
            }
          })
        } else {
          this.error = data.data
        }
      } catch (error) {
        console.error('Request failed:', error)
        this.error = 'Failed to execute command'
      } finally {
        this.reqLoading = false
      }
    }
  }
}
</script>